import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全部分类
          </h2>
          <p className="text-sm text-foreground-500">
            海量影视内容，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-50 group-hover:bg-primary-100/50 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500 group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors duration-300">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}